// @mui
import { styled } from '@mui/material/styles';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, Stack, Container, Typography, Link } from '@mui/material';
// routes
// hooks
// components
import Page from '../../components/Page';
// sections
import { LoginForm } from '../../sections/auth/login';
import { PATH_ADMIN_AUTH, PATH_AUTH } from '../../routes/paths';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  const location = useLocation();

  const isAdmin = location.pathname?.includes('admin');

  return (
    <Page title="Login">
      <RootStyle>
        <Container maxWidth="sm">
          <ContentStyle>
            <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
              <Box sx={{ flexGrow: 1 }}>
                <Typography
                  variant="h4"
                  gutterBottom
                  sx={{
                    color: '#e0e0e0',
                  }}
                >
                  Sign in to Edge Capital {isAdmin && 'Admin Panel'}
                </Typography>
                <Typography sx={{ color: '#ffffff' }}>Enter your loginId and password.</Typography>
              </Box>
            </Stack>
            <LoginForm />
            {isAdmin && (
              <Stack
                direction="row-reverse"
                alignItems="center"
                justifyContent="space-between"
                sx={{ my: 2 }}
              >
                <Link component={RouterLink} variant="subtitle2" to={PATH_ADMIN_AUTH.resetPassword}>
                  Forgot password?
                </Link>
              </Stack>
            )}
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
